export let PaymentMode=/*#__PURE__*/function(PaymentMode){PaymentMode["Online"]="online";PaymentMode["CardPresent"]="cardPresent";return PaymentMode;}({});